import EditorialMarketplacePage from "@faire/prototype-playground/workspace/ch/01-editorial-marketplace";
import { Route, Switch } from "react-router-dom";

export function ChrisHandelRoutes() {
  return (
    <Switch>
      <Route
        path="/ch/01-editorial-marketplace"
        component={EditorialMarketplacePage}
      />
    </Switch>
  );
}

export const slug = "ch";
